import { render, staticRenderFns } from "./ReportFilterTemplate.vue?vue&type=template&id=2ddae235"
import script from "./ReportFilterTemplate.vue?vue&type=script&lang=js"
export * from "./ReportFilterTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports